// extracted by mini-css-extract-plugin
module.exports = {"onlysupplier-channel":"onlysupplier-channel_3X0Wk","brand-spinner":"brand-spinner_1QTK_","brand-config-channel":"brand-config-channel_36FAG"};